<template>
  <popup v-model="showPayInfo" class="paypopup">
    <div class="popup-content">
      <!-- <div class="popup-desc">支付{{ album.cost | money }}元</div> -->
      <template v-if="!isWxWeb">
        <div>
          <label for="wechat" class="popup-item">
            <img src="@/assets/icon_wechat.png">
            <span style="flex:1">微信支付</span>
            <input id="wechat" type="radio" name="paytype" value="1" v-model="payMethod">
          </label>
        </div>
        <div>
          <label for="alipay" class="popup-item">
            <img src="@/assets/icon_alipay.png">
            <span style="flex:1">支付宝支付</span>
            <input id="alipay" type="radio" name="paytype" value="0" v-model="payMethod">
          </label>
        </div>
      </template>
      <template v-else>
        <div>
          <label for="wechat" class="popup-item">
            <img src="@/assets/icon_wechat.png">
            <span style="flex:1">微信支付</span>
            <input id="wechat" type="radio" name="paytype" value="2" v-model="payMethod">
          </label>
        </div>
      </template>
      <button @click="tpay">确认支付</button>
    </div>
  </popup>
</template>

<script>
import { Popup, Toast } from 'mint-ui';
import { isWeiXin, analogJump } from '@/utils/index'
import { pay, ready } from '@/api/pay'
import { paying } from '@/utils/pay'
export default {
  name: 'PayPopup',
  components: {
    Popup
  },
  props: {
    info: {
      type: Object,
      default: function() {
        return {}
      }
    },
    defaultMethod: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showPayInfo: false,
      isWxWeb: false,
      ispaying: false,
      timer: null
    }
  },
  created () {
    this.isWxWeb = isWeiXin()
    this.payReady()
    if(this.isWxWeb){
      this.payMethod = 2
    } else {
      this.payMethod = this.defaultMethod
    }
  },
  methods: {
    show() {
      this.showPayInfo = true
    },
    payReady() {
      if(!this.isWxWeb){
        return
      }
      ready({method: 2, redirect: window.location.href}).catch(error=>{
        this.$emit('paynoready', error.data)
      })
    },
    tpay(){
      if(this.ispaying) {
        Toast({
          message: "正在支付请稍后",
          position: 'bottom',
          duration: 1000
        })
        return
      }
      this.ispaying = true
      this.clearStatus()
      const params = {
        price: this.info.price,
        title: this.info.title,
        source: this.info.id,
        sign: this.info.sign,
        method: this.payMethod,
        type: this.type
      }
      pay(params).then((response)=>{
        this.showPayInfo = false
        var data = response.data.data
        paying(this.payMethod, data.url, data.return_url).then( url => {
          analogJump(url, '', false)
        })
      }).catch((error)=>{
        this.showPayInfo = false
        if(error.hasOwnProperty('code')){
          if(parseInt(error.code) === 401){
            this.$emit('paynoready', error.data)
          }
        } else if(error.message != 'Error'){
          this.$emit('nologin')
        }
      })
    },
    clearStatus(){
      if(this.timer){
        window.clearTimeout(this.timer)
      }
      this.timer = window.setTimeout(() => {
        this.ispaying = false;
      },5000);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.paypopup{
    padding: 16px;
    width: 70vw;
    text-align: left;
    .popup-desc{
      font-size: 19px;
    }
    .popup-item{
      display: flex;
      align-items: center;
      padding: 6px 0;
      border-bottom: #eee solid 1px;
      margin: 10px 0;
      font-size: 18px;
      img{
        width: 19px;
        margin-right: 6px;
      }
    }
    button{
      border: none;
      background-color: rgb(245, 121, 19);
      width: 100%;
      color: #eee;
      border-radius: 6px;
      padding: 10px;
      font-size: 16px;
      margin-top: 13px;
    }
}
</style>
